import { getAuthenticationState } from "@/graphql/queries";

export const authenticationState = {
  apollo: {
    authenticationState: getAuthenticationState,
  },
};
